import type { SVGProps } from "react";
export interface BadgeDollarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BadgeDollarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BadgeDollarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M8.656 2.585c1.69-2.355 5.282-2.276 6.846.236l.179.288.334-.076c2.882-.67 5.477 1.814 5.007 4.675l-.054.276-.078.333.29.182c2.593 1.614 2.593 5.388 0 7.003l-.29.179.078.334c.691 2.975-1.978 5.644-4.953 4.952l-.334-.077-.179.29c-1.614 2.592-5.389 2.592-7.003 0l-.182-.29-.332.077c-2.975.692-5.643-1.977-4.952-4.952l.077-.334-.289-.18c-2.593-1.614-2.593-5.388 0-7.002l.289-.182-.077-.333C2.342 5.01 5.01 2.342 7.985 3.034l.332.075.182-.288zm4.936 1.424a1.876 1.876 0 0 0-3.035-.207l-.148.207-.418.67c-.367.59-1.07.882-1.747.724l-.77-.178a1.874 1.874 0 0 0-2.25 2.25l.18.769a1.63 1.63 0 0 1-.517 1.595l-.207.152-.67.418a1.875 1.875 0 0 0 0 3.183l.67.417.207.153c.448.39.654 1 .517 1.593l-.18.77a1.875 1.875 0 0 0 2.25 2.25l.77-.178.255-.038a1.63 1.63 0 0 1 1.34.555l.152.207.418.67a1.875 1.875 0 0 0 3.183 0l.418-.67.152-.207a1.62 1.62 0 0 1 1.34-.555l.254.038.769.179.252.04a1.877 1.877 0 0 0 2.04-2.04l-.04-.252-.18-.769a1.62 1.62 0 0 1 .724-1.746l.67-.417a1.875 1.875 0 0 0 0-3.183l-.67-.418a1.625 1.625 0 0 1-.724-1.747l.18-.77.04-.25a1.876 1.876 0 0 0-2.292-2l-.77.18a1.63 1.63 0 0 1-1.593-.518l-.152-.206z"
      />
      <path
        fill={color}
        d="m11.297 10.278.005.051v.006s.003 0 .004.003l.007.01a.4.4 0 0 0 .054.045c.134.098.402.21.854.3 1.238.248 2.732 1.107 2.732 2.83 0 1.232-.782 2.225-1.842 2.64a1.122 1.122 0 0 1-2.22.025 2.9 2.9 0 0 1-1.714-1.608l-.071-.193-.031-.112a1.124 1.124 0 0 1 2.123-.706l.042.107.03.075a.64.64 0 0 0 .187.218c.104.078.271.155.543.155.454 0 .703-.324.703-.6 0-.096-.028-.182-.148-.289a1.4 1.4 0 0 0-.514-.268l-.262-.067c-.563-.113-1.21-.304-1.736-.687-.583-.425-.996-1.076-.996-1.937q0-.053.004-.105l.002-.003c.047-1.16.853-1.984 1.837-2.342a1.125 1.125 0 0 1 2.218-.014c.84.3 1.427.922 1.715 1.609l.073.192.031.111a1.126 1.126 0 0 1-2.124.707l-.043-.106-.03-.075a.64.64 0 0 0-.186-.22c-.104-.078-.272-.155-.544-.155a.9.9 0 0 0-.572.184c-.114.095-.13.175-.13.214z"
      />
    </svg>
  );
}
